import { Link } from "react-router-dom";
import { path } from "../../api/data/consts";
import { RoutingList } from "../../components/routingList/routingList";

export interface IParentLayoutPageProps {
  child?: JSX.Element;
}

const ParentLayout: React.FC<
  IParentLayoutPageProps
> = ({ child }) => (
  <div className="app-shell">
    <header className="app-header">
      <div className="app-header__inner">
        <Link
          className="app-brand"
          to={path.startPage}
        >
          <span className="app-brand__eyebrow">
            Tarot
          </span>

          <span className="app-brand__title">
            Расклады Таро
          </span>
        </Link>
      </div>
    </header>

    <div className="app-layout">
      <aside className="app-sidebar">
        <RoutingList />
      </aside>

      <main className="app-main">
        {child}
      </main>
    </div>
  </div>
);

export default ParentLayout;

